import React from 'react'
import axios from 'axios'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cadastrarTomador from '../../actions/cteos/tomador/cadastrarTomador'
import alterarTomador from '../../actions/cteos/tomador/alterarTomador';
import {
    renderField,
    required,
    renderFieldCheck,
    renderFieldText,
    renderFieldDataNascimento,
    renderFieldCep,
    apenasLetra,
    minTamanhoNome,
    maxTamanhoNome,
    validarCPF,
    renderFieldCpf,
    renderFieldCnpj,
    validarCNPJ,
    validarApenasNumero, renderFieldSelect, requiredSelect
} from '../../util/inputs';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import { showSuccessMsg } from '../../util/messagesUtil';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import { URL } from '../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import $ from 'jquery'
import {tipoIndicadorContribuicaoIE} from '../../util/constantsUtil';

export class ModalCadastrarTomador extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.limparCampos = this.limparCampos.bind(this);

        this.state = {
            tipoIndicadorContribuicaoIE: {}
        };
    }

    montarParametroTomador(values) {
        return {
            id: values.idTomador,
            nomePessoa: values.nomePessoa,
            numeroDocumento: values.numeroDocumento,
            dataNascimento: values.dataNascimento,
            endereco: {
                id: values.idEndereco,
                cep: values.cep,
                logradouro: values.logradouro,
                complemento: values.complemento,
                bairro: values.bairro,
                codigoCidade: this.props.origem.id,
                uf: this.props.origem.uf,
                numero: values.numero,
                nomeCidade: this.props.origem.nome
            },
            nomeFantasia: values.nomeFantasia,
            razaoSocial: values.razaoSocial,
            inscricaoEstadual: values.inscricaoEstadual ? values.inscricaoEstadual.replace(/[./-]/g, '') : '',
            inscricaoMunicipal: values.inscricaoMunicipal ? values.inscricaoMunicipal.replace(/[./-]/g, '') : '',
            cpf: values.numeroDocumento ? values.numeroDocumento.replace(/[./-]/g, '') : null,
            cnpj: values.numeroCnpj ? values.numeroCnpj.replace(/[./-]/g, '') : null,
            tipoTomador: values.cpf ? 'PF' : 'PJ',
            tipoIndicadorContribuicaoIE: this.state.tipoIndicadorContribuicaoIE.value,
            empresaId: this.props.empresaSelecionada.id
        };
    }

    submit(values) {
        if (values.idTomador) {
            this.props.alterarTomador(this.montarParametroTomador(values)).then(() => {
                showSuccessMsg('Tomador alterado com sucesso');
                this.props.buscarTomadores();
                this.fecharModal();
            });
        } else {
            this.props.cadastrarTomador(this.montarParametroTomador(values)).then((data) => {
                const cupom = data.payload;
                if (cupom) {
                    showSuccessMsg('Tomador cadastrado com sucesso');
                }
                this.props.buscarTomadores();
                this.fecharModal();
            })
        }
    }

    fecharModal() {
        $('#modalCadastrarTomador')
            .modal('hide');
        $('#modalCadastrarTomador')
            .hide();
        $('.modal-modalCadastrarTomador')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
        this.selecionarOrigem(null)
        this.props.reset('formularioCadastroTomador');
    }

    desmarcarCheckboxCpf(e) {
        if (e.target.checked) {
            this.props.changeFieldValue('formularioCadastroTomador', 'cpf', false);
        }
    }

    desmarcarCheckboxCnpj(e) {
        if (e.target.checked) {
            this.props.changeFieldValue('formularioCadastroTomador', 'cnpj', false);
        }
    }

    selecionarOrigem(origem) {
        this.props.selecionarOrigem(origem)
    }

    pesquisarPorCep(event) {
        const CEP = event.target.value.replace(/\D/g, '')
        if (CEP.length === 8) {
            const url = `${URL}/cep/public/${CEP}`
            axios.get(url, SLOW_REQUEST_CONFIG).then((resp) => {
                if (resp.status === 200) {
                    this.props.changeFieldValue('formularioCadastroTomador',
                        'logradouro', resp.data.logradouro);
                    this.props.changeFieldValue('formularioCadastroTomador',
                        'complemento', resp.data.complemento);
                    this.props.changeFieldValue('formularioCadastroTomador',
                        'bairro', resp.data.bairro);
                    this.props.changeFieldValue('formularioCadastroTomador',
                        'uf', resp.data.uf);
                }
            })
        }
        this.limparCampos()
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroTomador',
            'logradouro', '');
        this.props.changeFieldValue('formularioCadastroTomador',
            'complemento', '');
        this.props.changeFieldValue('formularioCadastroTomador',
            'bairro', '');
        this.props.changeFieldValue('formularioCadastroTomador',
            'uf', '');
    }

    limpaViagens () {
        this.props.selecionarOrigem(null)
      }

    handleSelecionarindicadorContribuicao(evento) {
        this.setState({ tipoIndicadorContribuicaoIE: evento });
    }
    
    exibirCamposEndereco() {
        return (
            <div>
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="cep" type="text" validate={[required]} component={renderFieldCep} label="CEP:"
                               css="form-control" readOnly={false} onChange={e => this.pesquisarPorCep(e)}/>
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name='tipoIndicadorContribuicaoIE'
                               options={tipoIndicadorContribuicaoIE.map(elemento => ({
                                   descricao: elemento.label,
                                   nome: elemento.value
                               }))}
                               placeholder='Selecione...'
                               onChange={(e) => this.handleSelecionarindicadorContribuicao(e)}
                               component={renderFieldSelect}
                               label='Indicador Contribuição:' validate={requiredSelect}/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-9 col-md-9">
                        <Field name="logradouro" type="text" validate={[required]} component={renderField}
                               label="Logradouro:"
                               css="form-control" readOnly={false}/>
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="bairro" type="text" validate={[required]} component={renderField} label="Bairro:"
                               css="form-control" readOnly={false}/>
                    </div>
                    <div className="col-12 col-sm-5 col-md-5">
                        <Field name="complemento" type="text" validate={[required]} component={renderField} label="Complemento:"
                            css="form-control" readOnly={false} />
                    </div>
                    <div className="col-12 col-sm-9 col-md-3">
                        <Field name="numero" type="text" validate={[required, validarApenasNumero]} component={renderField} label="Número:"
                            css="form-control" readOnly={false} />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 mt-2">
                        <label>Cidade:</label>
                    </div>
                    <SelecaoCidadeAutocomplete name='informeCidade'
                        selecionarCidade={this.props.selecionarOrigem}
                        value={this.props.origem}
                        limparViagens={this.limpaViagens.bind(this)}
                        ehVenda={true}
                    />
                </div>
                <div className="form-group area-codigo">
                    <Field name="idEndereco" type="hidden" component={renderField} css="form-control col-md-12" />
                    <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12"/>
                </div>
            </div>
        )
    }


    exibirCamposPessoaFisica() {
        return (
            <div>
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="nomePessoa"
                            css='form-control'
                            validate={[required, apenasLetra, minTamanhoNome, maxTamanhoNome]}
                            component={renderField}
                            label="Nome Completo" />
                    </div>
                    <div className="col-12 col-sm-3 col-md-3">
                        <Field name="numeroDocumento"
                            css='form-control'
                            validate={[required, validarCPF]}
                            component={renderFieldCpf}
                            label="Número CPF" />
                    </div>
                    <div className="col-12 col-sm-3 col-md-3">
                        <Field name="dataNascimento"
                            css='form-control'
                            component={renderFieldDataNascimento}
                            label="Data Nascimento" />
                    </div>
                </div>
            </div>
        )
    }

    exibirCamposEmpresa() {
        return (
            <div>
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="nomeFantasia"
                               css='form-control'
                               validate={[required]}
                               component={renderFieldText}
                               label="Nome Fantasia"/>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="razaoSocial"
                               css='form-control'
                               validate={[required]}
                               component={renderFieldText}
                               label="Razão Social"/>
                    </div>
                </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="numeroCnpj"
                               css='form-control'
                               validate={[required, validarCNPJ]}
                               component={renderFieldCnpj}
                               label="Número CNPJ"/>
                    </div>
                <div className="form-row">
                    <div className="col-12 col-sm-3 col-md-3">
                        {this.state.tipoIndicadorContribuicaoIE.value == 'CONTRIBUINTE_ICMS' ? <Field name="inscricaoEstadual"
                               css='form-control'
                               component={renderFieldText}
                               label="Inscrição Estadual"
                               validate={[required]}
                        />:
                        <Field name="inscricaoEstadual"
                               css='form-control'
                               component={renderFieldText}
                               label="Inscrição Estadual"
                        /> }
                    </div>
                    <div className="col-12 col-sm-3 col-md-3">
                        <Field name="inscricaoMunicipal"
                               css='form-control'
                               component={renderFieldText}
                               label="Inscrição Municipal"/>
                    </div>
                </div>
            </div>
        )
    }


    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarTomador' role='dialog'
                 aria-labelledby='modalCadastrarTomador' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{this.props.idPreco ? 'Editar Tomador' : 'Novo Tomador'}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    close
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12">
                                        <div className='form-row'>
                                            <div className='col-12 col-sm-3 col-md-3'>
                                                <Field name='cpf' type="checkbox" component={renderFieldCheck}
                                                    label="Pessoa Física"
                                                    css="form-check-input" readOnly={false}
                                                    onChange={(e) => this.desmarcarCheckboxCnpj(e)} />
                                            </div>
                                            <Field name='cnpj' type="checkbox" component={renderFieldCheck}
                                                label="Pessoa Jurídica"
                                                css="form-check-input" readOnly={false}
                                                onChange={(e) => this.desmarcarCheckboxCpf(e)} />
                                        </div>
                                        {this.props.cpf ? this.exibirCamposPessoaFisica() : ''}
                                        {this.props.cnpj ? this.exibirCamposEmpresa() : ''}
                                        {this.props.cpf || this.props.cnpj ? this.exibirCamposEndereco() : ''}
                                    </div>
                                </div>
                                <div className="form-group area-codigo">
                                    <Field name="idTomador" type="hidden" component={renderField}
                                        css="form-control col-md-12" />
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" disabled={invalid || submitting || pristine || !this.props.origem}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        cnpj: formValueSelector('formularioCadastroTomador')(state, 'cnpj'),
        cpf: formValueSelector('formularioCadastroTomador')(state, 'cpf'),
        idTomador: formValueSelector('formularioCadastroTomador')(state, 'idTomador'),
        origem: state.origem,
        nomePessoa: formValueSelector('formularioCadastroTomador')(state, 'nomePessoa'),
        numeroDocumento: formValueSelector('formularioCadastroTomador')(state, 'numeroDocumento'),
        numeroCnpj: formValueSelector('formularioCadastroTomador')(state, 'numeroCnpj'),
        dataNascimento: formValueSelector('formularioCadastroTomador')(state, 'dataNascimento'),
        nomeFantasia: formValueSelector('formularioCadastroTomador')(state, 'nomeFantasia'),
        razaoSocial: formValueSelector('formularioCadastroTomador')(state, 'razaoSocial'),
        inscricaoEstadual: formValueSelector('formularioCadastroTomador')(state, 'inscricaoEstadual'),
        inscricaoMunicipal: formValueSelector('formularioCadastroTomador')(state, 'inscricaoMunicipal'),
        cep: formValueSelector('formularioCadastroTomador')(state, 'cep'),
        tipoIndicadorContribuicaoIE: formValueSelector('formularioCadastroTomador')(state, 'tipoIndicadorContribuicaoIE')
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarTomador,
        selecionarOrigem,
        alterarTomador
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroTomador'
})(ModalCadastrarTomador));
